'use strict';

const isSmallView = require('../../modules/helpers/isSmallView');

function expandIngredient() {
  $(document).on('click', '.js-expand-ingredients', function () {
    const $parent = $(this).parents('.column-details');
    if (!$parent.hasClass('open')) {
      $parent.addClass('open');
      $(this).siblings('.ingredient-item').stop().show();
    } else {
      $parent.removeClass('open');
      $(this).siblings('.ingredient-item').not(':first').stop().slideUp(400);
      if ($(window).width() < 768) {
        $('html, body').animate({scrollTop: ($parent.offset().top - 90)}, 400);
      }
    }
  });
}

function scrollToIngredients() {
  $(document).on('click', '.js-scroll-ingredients', function () {
    const $ingredientsTab = $('.js-ingredients-tab');
    const $ingredientsAddcorion = $('.js-ingredients-acc-head');

    if (isSmallView()) {
        $('html, body').animate({scrollTop: ($('.js-product-tabs').offset().top - 60)}, 600);
        if (!$ingredientsAddcorion.hasClass('open')) {
            setTimeout(function () {
                $ingredientsAddcorion.click().focus();
            }, 300);
        }
    } else {
        $('html, body').animate({scrollTop: ($ingredientsTab.offset().top - 60)}, 600);
        if (!$ingredientsTab.hasClass('selected')) {
            setTimeout(function () {
                $ingredientsTab.click().focus();
            }, 600);
        }
    }
  });
}

function initializeEvents() {
  $(document).ready(function() {
    expandIngredient();
    scrollToIngredients();
  });
}

const productIngredient = {
  init: function() {
    initializeEvents();
  }
};

module.exports = productIngredient;
